import { Component, Input } from '@angular/core';
import { faCalendarAlt, faTicket } from '@fortawesome/pro-light-svg-icons';
import { AppSettings } from 'src/app/app-settings';
import { fixedPassFromLabel, isFixedPricePass } from 'src/app/helpers/fixed-price-pass';

@Component({
  selector: 'app-pass-card',
  templateUrl: './pass-card.component.html',
  styleUrls: ['./pass-card.component.scss']
})
export class PassCardComponent {
  @Input() pass: any;
  faCalendar = faCalendarAlt;
  faTicket = faTicket;
  urlImages = AppSettings.API_EVENTS_ASSETS;

  isFixedPrices(): boolean {
    return isFixedPricePass(this.pass);
  }

  fixedPriceLabel(): string {
    return fixedPassFromLabel(this.pass);
  }

  formatPrice(value: number): string {
    return new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 2,
      style: 'currency',
      currency: 'EUR'
    }).format(value);
  }
}
